<div class="container">

       <div class="text">
              <h1 class="title-text">Class Management</h1>
              <span>Use this page to hide or show classes...</span>
              <span>Classes that are checked will be shown on the dashboard each time you visit.</span><br>
       </div>
          
       <div class="cbox-scrollbar">
              <div class="cbox-container">
                     <div class="cboxes" *ngFor="let class of classes">
                            <div class=cbox>
                                   <input type="checkbox" 
                                   id="{{class.ID}}" 
                                   name="classnames" 
                                   [checked]="!class.Hidden" 
                                   (click)="updateClassFilter($event, class)">
                                   <label for="{{class.ID}}">&nbsp;{{class.Name}}</label>
                            </div>
                     </div>
              </div>
       </div>
       
     
       
       <button mat-flat-button color="primary" (click)="onNoClick()" >Ok</button>
</div>


